import { Extension } from "@tiptap/core";
import { Subscript as TiptapSubscript } from "@tiptap/extension-subscript";
import { Superscript as TiptapSuperscript } from "@tiptap/extension-superscript";

import ActionMoreButton from "../../extensions/MoreMark/components/ActionMoreButton";

export const MoreMark = Extension.create({
	name: "moreMark",
	addOptions() {
		return {
			...this.parent?.(),
			button({ editor, extension, t }) {
				const subscript = extension.options.subscript;
				const superscript = extension.options.superscript;
				const subBtn = {
					action: () => editor.commands.toggleSubscript(),
					isActive: () => editor.isActive("subscript") || false,
					icon: "Subscript",
					title: t("editor.subscript.tooltip"),
					shortcutKeys: ["mod", "."]
				};

				const superBtn = {
					action: () => editor.commands.toggleSuperscript(),
					isActive: () => editor.isActive("superscript") || false,
					icon: "Superscript",
					title: t("editor.superscript.tooltip"),
					shortcutKeys: ["mod", ","]
				};
				// const hasCode = hasExtension(editor, 'code');

				const items = [];

				if (subscript !== false) {
					items.push(subBtn);
				}
				if (superscript !== false) {
					items.push(superBtn);
				}

				return {
					component: ActionMoreButton,
					componentProps: {
						icon: "Type",
						tooltip: t("editor.moremark"),
						items
					}
				};
			}
		};
	},

	addExtensions() {
		const extensions = [];

		if (this.options.subscript !== false) {
			extensions.push(TiptapSubscript.configure(this.options.subscript));
		}

		if (this.options.superscript !== false) {
			extensions.push(TiptapSuperscript.configure(this.options.superscript));
		}

		return extensions;
	}
});
